import React from 'react';
import {
  Card,
  CardHeader,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  Paragraph,
  ParagraphHeader,
  SmallHeader,
  useBreakpoint,
} from '@axiom/ui';

import SmallBuilding from '../../public/svg/small-building.svg';
import Mail from '../../public/svg/mail.svg';
import { EnvUtil } from '../../utils/env-util';

export type TalentReputationUsefulLinksProps = {
  name?: string;
};

export const TalentReputationUsefulLinks = ({
  name = 'USEFUL-LINKS',
}: TalentReputationUsefulLinksProps = {}) => {
  const { isSmallScreen } = useBreakpoint();
  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>Performance Resources</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical" verticalGutter="32px">
          <Layout
            horizontalGutter="24px"
            wrap={isSmallScreen}
            name="PERFORMANCE_FEEDBACK_FAQ"
          >
            <LayoutItem>
              <SmallBuilding width="50px" height="50px" />
              <Gutter bottom="16px" />
            </LayoutItem>
            <LayoutItem fluid>
              <ParagraphHeader>Performance Feedback FAQs</ParagraphHeader>
              <Gutter bottom="8px" />
              <Paragraph>
                Have questions about how clients provide performance feedback?
                This guide will walk you through the processes involved.
              </Paragraph>
              <Gutter bottom="8px" />
              <a
                href={EnvUtil.performanceFeedbackGuide}
                target="_blank"
                rel="noopener noreferrer"
                data-test="PERFORMANCE_FEEDBACK_FAQ_BUTTON"
              >
                Talent Performance Feedback Guide.pdf
              </a>
            </LayoutItem>
          </Layout>
          <Layout
            horizontalGutter="24px"
            wrap={isSmallScreen}
            name="QUALTRICS_SURVEY_FORM"
          >
            <LayoutItem fluid>
              <Mail width="50px" height="50px" />
              <Gutter bottom="16px" />
            </LayoutItem>
            <LayoutItem>
              <ParagraphHeader>Get More Feedback</ParagraphHeader>
              <Gutter bottom="8px" />
              <Paragraph>
                Add more contacts to get more feedback. Simply fill out the form
                below and provide Axiom with client names that can give feedback
                on your performance.
              </Paragraph>
              <Gutter bottom="8px" />
              <a
                href={EnvUtil.qualtricsSurveyForm}
                target="_blank"
                rel="noopener noreferrer"
                data-test="QUALTRICS_SURVEY_FORM_BUTTON"
              >
                Feedback: Additional Contact Form
              </a>
            </LayoutItem>
          </Layout>
        </Layout>
      </CardSection>
    </Card>
  );
};
